var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "800px" },
              model: {
                value: _vm.show,
                callback: function ($$v) {
                  _vm.show = $$v
                },
                expression: "show",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "secondary white--text d-flex align-center justify-space-between",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "header-font",
                          staticStyle: { "font-size": "22px" },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.title) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-subtitle",
                    {
                      staticClass:
                        "secondary py-2 white--text d-flex align-center justify-space-between",
                    },
                    [
                      _c("span", { staticClass: "subheader-font body-2" }, [
                        _vm._v(_vm._s(_vm.subtitle)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _vm.activeTemplate
                        ? _c(
                            "v-form",
                            {
                              ref: "formRef",
                              staticClass: "d-flex align-center flex-wrap",
                              attrs: { name: "formName" },
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onCreateClick()
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 body-1 font-weight-bold primary--text py-1",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("collections.visibility")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "mt-0",
                                  attrs: {
                                    dense: "",
                                    row: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.activeTemplate.visibilityId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.activeTemplate,
                                        "visibilityId",
                                        $$v
                                      )
                                    },
                                    expression: "activeTemplate.visibilityId",
                                  },
                                },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        top: "",
                                        color: "lightSecondary lighten-4",
                                        "max-width": "300",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-radio",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        value: 1,
                                                        color: "primary",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "collections.privacity.publicTitle"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mx-1",
                                                                    attrs: {
                                                                      color:
                                                                        "grey",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "public"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    on
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        4118970061
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "black--text body-1" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "collections.privacity.publicDescription"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        top: "",
                                        color: "lightSecondary lighten-4",
                                        "max-width": "300",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-radio",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        value: 2,
                                                        color: "primary",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "collections.privacity.privateTitle"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mx-1",
                                                                    attrs: {
                                                                      color:
                                                                        "grey",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "lock"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    on
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2063356520
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "black--text body-1" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "collections.privacity.privateDescription"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        top: "",
                                        color: "lightSecondary lighten-4",
                                        "max-width": "300",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-radio",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        value: 3,
                                                        color: "primary",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "collections.privacity.supervisedTitle"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mx-1",
                                                                    attrs: {
                                                                      color:
                                                                        "grey",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "visibility"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    on
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        101398437
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "black--text body-1" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "collections.privacity.supervisedDescription"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-center w-50 mt-5",
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "slim-input",
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      label: _vm.$t("settings.templateName"),
                                      clearable: "",
                                      rules: _vm.radarTemplateRequiredRules,
                                    },
                                    model: {
                                      value: _vm.activeTemplate.radarName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.activeTemplate,
                                          "radarName",
                                          $$v
                                        )
                                      },
                                      expression: "activeTemplate.radarName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center w-50 mb-4 pl-3",
                                },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      color: "secondary",
                                      "hide-details": "",
                                      dense: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "settings.radarDefault"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      441372131
                                    ),
                                    model: {
                                      value: _vm.activeTemplate.defaultRadar,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.activeTemplate,
                                          "defaultRadar",
                                          $$v
                                        )
                                      },
                                      expression: "activeTemplate.defaultRadar",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-center w-50 mt-0",
                                },
                                [
                                  _vm.activeTemplate.radarType === "player" ||
                                  (_vm.activeTemplate.id &&
                                    _vm.activeTemplate.positionId)
                                    ? _c("v-autocomplete", {
                                        staticClass: "slim-input",
                                        attrs: {
                                          items: _vm.positions,
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                          "item-text": "name",
                                          "item-value": "id",
                                          label: this.$t("general.position"),
                                        },
                                        model: {
                                          value: _vm.activeTemplate.positionId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.activeTemplate,
                                              "positionId",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "activeTemplate.positionId",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-100" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center mt-2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "primary--text font-weight-bold text-h6",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("general.add")) +
                                              " " +
                                              _vm._s(_vm.$t("general.stats"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "px-0",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c("GeneralFilter", {
                                        staticClass: "elevation-2",
                                        attrs: {
                                          items: _vm.availableStatsByProduct,
                                          minLength: 1,
                                          exactCoincidence: "",
                                          excludedFields: [
                                            "arrigo",
                                            "category",
                                            "categoryId",
                                            "code",
                                            "id",
                                            "adar",
                                            "player",
                                            "playerScout",
                                            "statTypeId",
                                            "team",
                                            "tooltip",
                                          ],
                                        },
                                        on: {
                                          filterChange: function ($event) {
                                            return _vm.onFilterChange($event)
                                          },
                                          inputChange: function ($event) {
                                            return _vm.onFilterInputChange(
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.categories
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "darkgrey--text font-weight-bold text-body-1",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.availableProducts"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "py-1 px-2 my-1 d-flex",
                                              attrs: {
                                                rounded: "",
                                                elevation: "0",
                                                outlined: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-wrap align-self-start",
                                                },
                                                _vm._l(
                                                  _vm.products,
                                                  function (product, index) {
                                                    return _c(
                                                      "v-tooltip",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          "max-width": "300",
                                                          top: "",
                                                          color:
                                                            "lightSecondary lighten-4",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-chip",
                                                                    _vm._g(
                                                                      {
                                                                        staticClass:
                                                                          "mr-2 my-1 d-flex justify-center",
                                                                        attrs: {
                                                                          outlined:
                                                                            !product.active,
                                                                          color:
                                                                            "secondary",
                                                                          label: true,
                                                                          small:
                                                                            "",
                                                                          disabled:
                                                                            _vm.disableCategories ||
                                                                            product.disabled,
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.onProductClick(
                                                                                product
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "me-1",
                                                                          style:
                                                                            product.icon.startsWith(
                                                                              "fa-"
                                                                            )
                                                                              ? "font-size: 10px"
                                                                              : "font-size: 13px",
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                product.active
                                                                                  ? "white"
                                                                                  : "secondary",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                          " +
                                                                              _vm._s(
                                                                                product.icon
                                                                              ) +
                                                                              "\n                        "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "body-2 font-weight-medium",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              product.name
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex flex-column black--text body-1",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "font-weight-bold",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    product.name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "monospace-font body-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    product.desc
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w-100 body-1 font-weight-bold primary--text pb-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t("general.categories")
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "py-1 px-2 my-1 d-flex",
                                              attrs: {
                                                rounded: "",
                                                elevation: "0",
                                                outlined: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-wrap align-self-start",
                                                },
                                                _vm._l(
                                                  _vm.availableCategoriesByProduct,
                                                  function (category, index) {
                                                    return _c(
                                                      "v-tooltip",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          "max-width": "300",
                                                          top: "",
                                                          color:
                                                            "lightSecondary lighten-4",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-chip",
                                                                    _vm._g(
                                                                      {
                                                                        staticClass:
                                                                          "mr-2 my-1 d-flex justify-center",
                                                                        attrs: {
                                                                          outlined:
                                                                            !category.active,
                                                                          color:
                                                                            "secondary",
                                                                          label: true,
                                                                          small:
                                                                            "",
                                                                          disabled:
                                                                            _vm.disableCategories,
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.onCategoryClick(
                                                                                category
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      category
                                                                        .product
                                                                        .icon
                                                                        ? _c(
                                                                            "v-icon",
                                                                            {
                                                                              staticClass:
                                                                                "me-1",
                                                                              style:
                                                                                category.product.icon.startsWith(
                                                                                  "fa-"
                                                                                )
                                                                                  ? "font-size: 10px"
                                                                                  : "font-size: 13px",
                                                                              attrs:
                                                                                {
                                                                                  color:
                                                                                    category.active
                                                                                      ? "white"
                                                                                      : "secondary",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                          " +
                                                                                  _vm._s(
                                                                                    category
                                                                                      .product
                                                                                      .icon
                                                                                  ) +
                                                                                  "\n                        "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "body-2 font-weight-medium",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              category.name
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex flex-column black--text body-1",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "font-weight-bold",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    category.name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "monospace-font body-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    category
                                                                      .product
                                                                      .name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.categoryModel
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "w-100 body-1 font-weight-bold primary--text pb-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.categoryModel.name
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "py-1 px-2 my-1 d-flex",
                                              attrs: {
                                                rounded: "",
                                                elevation: "0",
                                                outlined: "",
                                              },
                                            },
                                            [
                                              _vm.filteredStats.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-wrap align-self-start",
                                                    },
                                                    _vm._l(
                                                      _vm.filteredStats,
                                                      function (stat, index) {
                                                        return _c(
                                                          "v-tooltip",
                                                          {
                                                            key: index,
                                                            attrs: {
                                                              "max-width":
                                                                "300",
                                                              top: "",
                                                              color:
                                                                "lightSecondary lighten-4",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-chip",
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              "mr-2 my-1 d-flex justify-center",
                                                                            attrs:
                                                                              {
                                                                                outlined:
                                                                                  !stat.active,
                                                                                color:
                                                                                  "lightSecondary",
                                                                                label: true,
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onStatClick(
                                                                                    stat
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "body-2 font-weight-medium",
                                                                              class:
                                                                                stat.active
                                                                                  ? "white--text"
                                                                                  : "lightSecondary--text",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  stat.name
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex flex-column black--text body-1",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-weight-bold",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        stat.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "monospace-font body-2",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        stat
                                                                          .product
                                                                          .name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                stat.name !==
                                                                stat.tooltip
                                                                  ? _c("span", {
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              stat.tooltip
                                                                            ),
                                                                        },
                                                                    })
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-center align-center mt-1",
                                                      staticStyle: {
                                                        width: "100%",
                                                        height: "100%",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-alert",
                                                        {
                                                          staticClass:
                                                            "py-1 mb-1 body-1 font-weight-medium",
                                                          attrs: {
                                                            dense: "",
                                                            type: "warning",
                                                            color:
                                                              "primary lighten-3",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "general.noDataGivenFilters"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "d-flex" }, [
                                            _vm.activeTemplate.stats.length
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "darkgrey--text font-weight-bold text-body-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.$t("general.new")
                                                        ) +
                                                        " '" +
                                                        _vm._s(
                                                          _vm.activeTemplate
                                                            .radarName
                                                        ) +
                                                        "' " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "playerRecruitment.template"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.warningTextTemplates
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold text-body-1 pl-3 red--text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.warningTextTemplates
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                          _vm._v(" "),
                                          _vm.activeTemplate.stats.length
                                            ? _c(
                                                "v-card",
                                                {
                                                  staticClass:
                                                    "py-1 px-2 my-1 d-flex",
                                                  attrs: {
                                                    rounded: "",
                                                    elevation: "0",
                                                    outlined: "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex px-2 py-1 flex-wrap align-self-start",
                                                    },
                                                    _vm._l(
                                                      _vm.activeTemplate.stats,
                                                      function (stat, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass: "stat",
                                                          },
                                                          [
                                                            _c(
                                                              "drop",
                                                              {
                                                                staticClass:
                                                                  "flex-grow-1",
                                                                attrs: {
                                                                  "drop-effect":
                                                                    "move",
                                                                  "effect-allowed":
                                                                    "move",
                                                                },
                                                                on: {
                                                                  drop: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onDropStat(
                                                                      $event,
                                                                      index
                                                                    )
                                                                  },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "drag",
                                                                  {
                                                                    staticClass:
                                                                      "main-stat d-flex",
                                                                    staticStyle:
                                                                      {
                                                                        cursor:
                                                                          "move",
                                                                      },
                                                                    attrs: {
                                                                      "transfer-data":
                                                                        {
                                                                          stat: stat,
                                                                          index:
                                                                            index,
                                                                        },
                                                                      "drop-effect":
                                                                        "move",
                                                                      "effect-allowed":
                                                                        [
                                                                          "move",
                                                                        ],
                                                                    },
                                                                    on: {
                                                                      dragstart:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.dragging = true
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot: "image",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-chip",
                                                                          {
                                                                            staticClass:
                                                                              "d-flex justify-center",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "green",
                                                                                label: true,
                                                                                small:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          [
                                                                            stat
                                                                              .product
                                                                              .icon
                                                                              ? _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    staticClass:
                                                                                      "me-1",
                                                                                    style:
                                                                                      stat.product.icon.startsWith(
                                                                                        "fa-"
                                                                                      )
                                                                                        ? "font-size: 10px"
                                                                                        : "font-size: 13px",
                                                                                    attrs:
                                                                                      {
                                                                                        color:
                                                                                          "white",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                              " +
                                                                                        _vm._s(
                                                                                          stat
                                                                                            .product
                                                                                            .icon
                                                                                        ) +
                                                                                        "\n                            "
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "body-2 white--text font-weight-medium",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    stat.name
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-badge",
                                                                      {
                                                                        key: index,
                                                                        staticClass:
                                                                          "mr-4 mb-4",
                                                                        attrs: {
                                                                          content:
                                                                            index +
                                                                            1,
                                                                          color:
                                                                            "secondary",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-tooltip",
                                                                          {
                                                                            key: index,
                                                                            attrs:
                                                                              {
                                                                                "max-width":
                                                                                  "300",
                                                                                disabled:
                                                                                  "",
                                                                                top: "",
                                                                                color:
                                                                                  "lightSecondary lighten-4",
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "activator",
                                                                                    fn: function ({
                                                                                      on,
                                                                                    }) {
                                                                                      return [
                                                                                        _c(
                                                                                          "v-chip",
                                                                                          _vm._g(
                                                                                            {
                                                                                              staticClass:
                                                                                                "d-flex justify-center",
                                                                                              attrs:
                                                                                                {
                                                                                                  color:
                                                                                                    "green",
                                                                                                  label: true,
                                                                                                  small:
                                                                                                    "",
                                                                                                },
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.onStatClick(
                                                                                                      stat
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            },
                                                                                            on
                                                                                          ),
                                                                                          [
                                                                                            stat
                                                                                              .product
                                                                                              .icon
                                                                                              ? _c(
                                                                                                  "v-icon",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "me-1",
                                                                                                    style:
                                                                                                      stat.product.icon.startsWith(
                                                                                                        "fa-"
                                                                                                      )
                                                                                                        ? "font-size: 10px"
                                                                                                        : "font-size: 13px",
                                                                                                    attrs:
                                                                                                      {
                                                                                                        color:
                                                                                                          "white",
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "\n                                  " +
                                                                                                        _vm._s(
                                                                                                          stat
                                                                                                            .product
                                                                                                            .icon
                                                                                                        ) +
                                                                                                        "\n                                "
                                                                                                    ),
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e(),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "body-2 white--text font-weight-medium",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    stat.name
                                                                                                  )
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                true
                                                                              ),
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "d-flex flex-column black--text body-1",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "font-weight-bold",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        stat.name
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "monospace-font body-2",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        stat
                                                                                          .product
                                                                                          .name
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                stat.name !==
                                                                                stat.tooltip
                                                                                  ? _c(
                                                                                      "span",
                                                                                      {
                                                                                        domProps:
                                                                                          {
                                                                                            innerHTML:
                                                                                              _vm._s(
                                                                                                stat.tooltip
                                                                                              ),
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : _vm._e(),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "px-2 py-1 mr-1 align-self-start text-caption rounded orange--text",
                                                                        staticStyle:
                                                                          {
                                                                            border:
                                                                              "1px dashed orange",
                                                                          },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                "x-small":
                                                                                  "",
                                                                                color:
                                                                                  "orange",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " \n                              " +
                                                                                _vm._s(
                                                                                  _vm.dragging
                                                                                    ? "fa-grip"
                                                                                    : "fa-up-down-left-right"
                                                                                ) +
                                                                                "\n                              "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  2
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class:
                                                _vm.activeTemplate.stats
                                                  .length == _vm.maxStatsAllowed
                                                  ? "font-weight-bold red--text"
                                                  : "",
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.activeTemplate.stats
                                                      .length
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "game.gamePossessionMap.of"
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(_vm.maxStatsAllowed) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("general.maximum")
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            staticClass: "flex-grow-1",
                                            attrs: { type: "list-item@5" },
                                          }),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "pr-6 pb-4 d-flex justify-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "elevation-0 monospace-font px-4",
                          attrs: {
                            color: _vm.$vuetify.theme.dark
                              ? "white"
                              : "secondary darken-1",
                            rounded: "",
                            outlined: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onCancelClick()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "elevation-0 monospace-font white--text px-4",
                          attrs: {
                            rounded: "",
                            color: "primary",
                            disabled:
                              !_vm.hasStats || !_vm.activeTemplate.radarName,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onCreateClick()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("general.create")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }